import { render, staticRenderFns } from "./EmployerDashboard.vue?vue&type=template&id=72c88e51&scoped=true"
import script from "./EmployerDashboard.vue?vue&type=script&lang=js"
export * from "./EmployerDashboard.vue?vue&type=script&lang=js"
import style0 from "./EmployerDashboard.vue?vue&type=style&index=0&id=72c88e51&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c88e51",
  null
  
)

export default component.exports